module.exports = __webpack_public_path__ + "images/company/rank_medal/request_count_rank/1_58a5967aed4a1b15449c1d3d4e67efb6.png";